import { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import FloatingInstagramButton from './components/FloatingInstagramButton';
import RouteExperienceManager from './components/RouteExperienceManager';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import HomePage from './pages/HomePage';
import ProductPage from './pages/ProductPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import ProfilePage from './pages/ProfilePage';

export default function App() {
  useEffect(() => {
    const isImageNode = (target) => target instanceof HTMLElement && Boolean(target.closest('img, picture, figure'));

    const blockImageContextMenu = (event) => {
      if (isImageNode(event.target)) {
        event.preventDefault();
      }
    };

    const blockImageDrag = (event) => {
      if (isImageNode(event.target)) {
        event.preventDefault();
      }
    };

    const blockSaveShortcuts = (event) => {
      if ((event.ctrlKey || event.metaKey) && ['s', 'u'].includes(event.key.toLowerCase())) {
        event.preventDefault();
      }
    };

    document.addEventListener('contextmenu', blockImageContextMenu);
    document.addEventListener('dragstart', blockImageDrag);
    document.addEventListener('keydown', blockSaveShortcuts);

    return () => {
      document.removeEventListener('contextmenu', blockImageContextMenu);
      document.removeEventListener('dragstart', blockImageDrag);
      document.removeEventListener('keydown', blockSaveShortcuts);
    };
  }, []);

  return (
    <BrowserRouter>
      <RouteExperienceManager />
      <AuthProvider>
        <CartProvider>
          <div className="app-shell">
            <Header />
            <main className="content-shell">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/product" element={<ProductPage />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/signup" element={<SignupPage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
            <Footer />
            <FloatingInstagramButton />
          </div>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
